module.exports = __webpack_public_path__ + "img/Icon-ok.19c03480.svg";